import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StatusStyle } from '@pf/shared-common';
import { ChipStatus } from './chip.component';

export type ConnectedChip = {
    label: string;
    active?: boolean;
    style?: StatusStyle;
};

@Component({
    selector: 'pf-connected-chips',
    template: `
        @if (pfPrefix) {
            <pf-text>{{ pfPrefix }}</pf-text>
        }
        @for (chip of chips; track $index; let last = $last) {
            <pf-chip
                [pfStatus]="chip.style || pfStatus"
                [class.pf-chip-active]="chip.active"
                (click)="last ? lastChipClick.emit() : null"
                >{{ chip.label }}</pf-chip
            >

            @if (!last) {
                <pf-icon iconType="collapse" [rotate]="90"></pf-icon>
            }
        }
    `,
    styles: `
        :host {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            gap: 2px;
            --pf-chip-border-radius: var(--pf-chip-border-radius, 0);
        }
    `,
    standalone: false,
})
export class ConnectedChipsComponent {
    @Input() chips: ConnectedChip[] = [];
    @Input() pfPrefix?: string;
    @Input() pfStatus?: ChipStatus;
    @Output() lastChipClick = new EventEmitter<void>();
}
